import React from "react";
import { cn } from "../../lib/utils";

export function InvoiceIcon({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      viewBox="0 0 18 22"
      className={cn('h-4 w-4', className)}
      {...props}
    >
      <title>invoice-fill</title>
      <path strokeLinecap="round" strokeLinejoin="round" d="M17.125 19.125C17.125 19.4565 16.9933 19.7745 16.7589 20.0089C16.5245 20.2433 16.2065 20.375 15.875 20.375H2.125C1.79348 20.375 1.47554 20.2433 1.24112 20.0089C1.0067 19.7745 0.875 19.4565 0.875 19.125V2.875C0.875 2.54348 1.0067 2.22554 1.24112 1.99112C1.47554 1.7567 1.79348 1.625 2.125 1.625H10.9825C11.3138 1.62507 11.6315 1.75665 11.8658 1.99083L16.7592 6.88417C16.9933 7.1185 17.1249 7.43621 17.125 7.7675V19.125Z"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M17.125 7.875H12.125C11.7935 7.875 11.4755 7.7433 11.2411 7.50888C11.0067 7.27446 10.875 6.95652 10.875 6.625V1.625"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.16667 10.6617C4.34714 10.8987 4.5821 11.0887 4.85163 11.2157C5.12116 11.3426 5.41731 11.4027 5.715 11.3908C6.66417 11.3908 7.43417 10.8133 7.43417 10.1017C7.43417 9.38999 6.66667 8.81332 5.71833 8.81332C4.77 8.81332 4 8.23582 4 7.52332C4 6.81082 4.77 6.23415 5.71833 6.23415C6.01605 6.22209 6.31228 6.28208 6.58184 6.40902C6.85141 6.53597 7.08634 6.72613 7.26667 6.96332"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5.71833 11.3908V12.25"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5.71833 5.375V6.23417"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 13.5H14"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.625 17.25H14"/>
    </svg>
  )
} 
